function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        stroke: #fff;\r\n        stroke-width: 1.2px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-5, .cls-6 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Look",
  transform: "translate(-15606.9 -12549.9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_638",
  "data-name": "Group 638",
  transform: "translate(15613.312 12556.301)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_31",
  "data-name": "Path 31",
  className: "cls-1",
  transform: "translate(-1 -3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M12.291,3c8.083,0,11.291,5.958,11.291,6.917s-3.158,6.917-11.291,6.917S1,10.986,1,9.917,4.207,3,12.291,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M 12.29063892364502 4.200000762939453 C 8.483089447021484 4.200000762939453 5.998228073120117 5.617110252380371 4.584169387817383 6.805920600891113 C 3.037008285522461 8.106633186340332 2.328065872192383 9.48382568359375 2.210220336914063 9.918570518493652 C 2.326007843017578 10.35369205474854 3.026948928833008 11.73028755187988 4.56315803527832 13.02680015563965 C 5.972589492797852 14.21631050109863 8.457319259643555 15.6342601776123 12.29063892364502 15.6342601776123 C 19.25687789916992 15.6342601776123 22.05938529968262 10.89134502410889 22.36432838439941 9.918721199035645 C 22.05534744262695 8.945986747741699 19.23587608337402 4.200000762939453 12.29063892364502 4.200000762939453 M 12.29063892364502 3 C 20.37395858764648 3 23.58127975463867 8.957710266113281 23.58127975463867 9.917130470275879 C 23.58127975463867 10.87655067443848 20.42341995239258 16.83426094055176 12.29063892364502 16.83426094055176 C 4.157848358154297 16.83426094055176 0.9999980926513672 10.98624038696289 0.9999980926513672 9.917130470275879 C 0.9999980926513672 8.848020553588867 4.207319259643555 3 12.29063892364502 3 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_16",
  "data-name": "Ellipse 16",
  className: "cls-2",
  transform: "translate(6.342 1.868)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 4.993,
  cy: 4.993,
  r: 4.993
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 4.993,
  cy: 4.993,
  r: 4.393
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  className: "cls-3",
  d: "M3.462,0A2.891,2.891,0,0,1,6.353,2.891",
  transform: "translate(7.873 3.97)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_354",
  "data-name": "Path 354",
  className: "cls-4",
  d: "M8,0V6H0",
  transform: "translate(15615.5 12556.5) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_356",
  "data-name": "Path 356",
  className: "cls-4",
  d: "M0,0V6.011H8",
  transform: "translate(15641.5 12556.512) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_358",
  "data-name": "Path 358",
  className: "cls-4",
  d: "M0,0V6.011H8",
  transform: "translate(15607.5 12569.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_355",
  "data-name": "Path 355",
  className: "cls-4",
  d: "M8,0V6H0",
  transform: "translate(15633.5 12569.5)"
}));

var SvgLook = function SvgLook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35.199 26.211",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Look.e2e21051.svg";
export { ForwardRef as ReactComponent };